import { render, staticRenderFns } from "./modal-custom-recipients.vue?vue&type=template&id=71500eaf&scoped=true&lang=pug"
import script from "./modal-custom-recipients.js?vue&type=script&lang=js&external"
export * from "./modal-custom-recipients.js?vue&type=script&lang=js&external"
import style0 from "./modal-custom-recipients.vue?vue&type=style&index=0&id=71500eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71500eaf",
  null
  
)

export default component.exports